import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const AreaAccordion = ({
  children,
  Actions,
  headTitle,
  accordionId,
  accordionName,
  tQuestions,
  tAnswers,
  handleActive,
}) => {
  const RenderActions = useMemo(() => Actions, [Actions])();

  return (
    <S.AccordionContainer>
      <S.Checked
        inputType={accordionName ? 'radio' : 'checkbox'}
        id={accordionId}
        name={accordionName || accordionId}
        onChange={handleActive}
      />
      <S.AccordionHead
        htmlFor={accordionId}
        completed={tQuestions && tAnswers === tQuestions}
      >
        <S.AccordionHeadTitle>{headTitle}</S.AccordionHeadTitle>
        <div>
          {!!tQuestions && (
            <S.Counter>
              {tAnswers}/{tQuestions}
            </S.Counter>
          )}

          <S.MoreActionsWrapper>{RenderActions || ''}</S.MoreActionsWrapper>
          <S.AccordionHeadIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="14"
              viewBox="0 0 13 8"
              fill="none"
            >
              <path d="M1 1L6.5 6.5L12 1" stroke="#ffffff" />
            </svg>
          </S.AccordionHeadIcon>
        </div>
      </S.AccordionHead>
      <S.AccordionContent>{children}</S.AccordionContent>
    </S.AccordionContainer>
  );
};

export default AreaAccordion;

AreaAccordion.defaultProps = {
  accordionName: '',
  tQuestions: 0,
  tAnswers: 0,
  handleActive: e => {
    e.persist();
    const { target, nativeEvent } = e;
    const { checked } = target;
    const { scrollTo, outerHeight } = window;
    if (checked) {
      scrollTo(0, outerHeight - nativeEvent.clientY);
    }
  },
};

AreaAccordion.propTypes = {
  Actions: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
  children: PropTypes.node.isRequired,
  headTitle: PropTypes.string.isRequired,
  accordionId: PropTypes.string.isRequired,
  accordionName: PropTypes.string,
  tQuestions: PropTypes.number,
  tAnswers: PropTypes.number,
  handleActive: PropTypes.func,
};
